import { defineComponent as p, useCssModule as f, useSlots as _, createElementBlock as o, openBlock as s, createBlock as g, createCommentVNode as n, createElementVNode as u, renderSlot as a, toDisplayString as i, normalizeClass as m, unref as r, createTextVNode as y } from "vue";
import { t as w } from "./locale.js";
import { _ as b } from "./Illustration.vue_vue_type_script_setup_true_lang-BBqgoJO8.js";
import { _ as h } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const x = {
  key: "empty",
  class: "stash-empty-state",
  "data-test": "stash-empty-state"
}, k = {
  key: 0,
  class: "tw-flex tw-flex-col tw-items-center tw-text-center md:tw-flex-row md:tw-text-left"
}, v = { class: "tw-mb-1.5" }, $ = ["alt", "src"], S = /* @__PURE__ */ p({
  name: "ll-empty-state",
  __name: "EmptyState",
  props: {
    image: { default: () => ({
      alt: "",
      src: ""
    }) },
    text: { default: "" },
    title: { default: "" },
    subtitle: { default: "" },
    footnote: { default: "" },
    vignette: { default: void 0 }
  },
  setup(d) {
    const t = d, c = f(), e = _();
    return (l, N) => (s(), o("div", x, [
      t.title || e.title || t.subtitle || e.subtitle || t.vignette ? (s(), o("div", k, [
        t.vignette ? (s(), g(b, {
          key: 0,
          "data-test": "stash-empty-state|illustration",
          type: "vignette",
          class: "tw-mx-3",
          name: t.vignette,
          size: 300
        }, null, 8, ["name"])) : n("", !0),
        u("section", null, [
          a(l.$slots, "title", {}, () => [
            u("h3", v, i(t.title), 1)
          ]),
          a(l.$slots, "subtitle", {}, () => [
            t.subtitle || e.subtitle ? (s(), o("p", {
              key: 0,
              class: m({ "tw-mb-8": e.button, "tw-mb-0": !e.button })
            }, i(t.subtitle), 3)) : n("", !0)
          ]),
          a(l.$slots, "button"),
          a(l.$slots, "footnote", {}, () => [
            t.footnote ? (s(), o("p", {
              key: 0,
              class: m(["tw-mb-0 tw-text-xs", { "tw-mt-3": e.button }])
            }, i(t.footnote), 3)) : n("", !0)
          ])
        ])
      ])) : (s(), o("div", {
        key: 1,
        class: m(["tw-mx-auto tw-my-0 tw-flex tw-items-center tw-justify-center tw-py-12", [r(c).root, { "tw-text-center": !t.image.src && !e.image }]])
      }, [
        a(l.$slots, "image", {}, () => [
          t.image.src ? (s(), o("img", {
            key: 0,
            class: m(["tw-mr-6", r(c).image]),
            alt: t.image.alt,
            src: t.image.src,
            "data-test": "stash-empty-state__img"
          }, null, 10, $)) : n("", !0)
        ]),
        y(" " + i(t.text || r(w)("ll.emptyState.noResults")), 1)
      ], 2))
    ]));
  }
}), C = "_root_hagg9_2", E = "_image_hagg9_6", B = {
  root: C,
  image: E
}, M = {
  $style: B
}, R = /* @__PURE__ */ h(S, [["__cssModules", M]]);
export {
  R as default
};
//# sourceMappingURL=EmptyState.js.map
